import React from 'react'

const VW_BLUE = '#001E50'

function pctInRange(x, lo, hi) {
  if (!Number.isFinite(x) || hi <= lo) return 50
  return Math.min(100, Math.max(0, ((x - lo) / (hi - lo)) * 100))
}

export function MarketPositionScale({
  prix,
  scale,
  dotLabel = 'Votre prix',
  title = 'Position prix vs marché',
  axisLabels = { left: 'Min. marché', center: 'Médiane', right: 'Max. marché' },
}) {
  if (!scale || prix == null || !Number.isFinite(Number(prix))) return null
  const p = Number(prix)
  const { lo, hi, median } = scale
  const xStock = pctInRange(p, lo, hi)
  const xMed = pctInRange(median, lo, hi)
  return (
    <div style={{ marginBottom: 4 }}>
      {title ? (
        <div
          style={{
            fontSize: 10,
            fontWeight: 600,
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            color: 'var(--text-tertiary)',
            marginBottom: 8,
          }}
        >
          {title}
        </div>
      ) : null}
      <div style={{ position: 'relative', height: 40, marginBottom: 22 }}>
        <div
          style={{
            position: 'absolute',
            left: 0,
            right: 0,
            top: 18,
            height: 6,
            borderRadius: 3,
            background: 'rgba(226,232,240,0.08)',
            border: '1px solid rgba(148,163,184,0.2)',
          }}
        />
        {[0, xMed, 100].map((tick, i) => (
          <div
            key={i}
            style={{
              position: 'absolute',
              left: `${tick}%`,
              top: 14,
              width: 1,
              height: 14,
              transform: 'translateX(-50%)',
              background: 'rgba(148,163,184,0.45)',
            }}
          />
        ))}
        <div
          style={{
            position: 'absolute',
            left: `${xStock}%`,
            top: 0,
            transform: 'translateX(-50%)',
            textAlign: 'center',
            minWidth: 72,
          }}
        >
          <div style={{ fontSize: 10, color: 'var(--text-tertiary)', marginBottom: 2 }}>{dotLabel}</div>
          <div
            style={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              margin: '0 auto',
              background: VW_BLUE,
              border: '2px solid rgba(255,255,255,0.85)',
              boxSizing: 'border-box',
            }}
          />
        </div>
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          gap: 8,
          fontSize: 11,
          color: 'var(--text-secondary)',
          textAlign: 'center',
        }}
      >
        <span>{Number(lo).toLocaleString('fr-CH')}</span>
        <span style={{ fontWeight: 600, color: 'var(--text)' }}>{Number(median).toLocaleString('fr-CH')}</span>
        <span>{Number(hi).toLocaleString('fr-CH')}</span>
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          gap: 8,
          fontSize: 10,
          color: 'var(--text-tertiary)',
          textAlign: 'center',
          marginTop: 4,
        }}
      >
        <span>{axisLabels.left}</span>
        <span>{axisLabels.center}</span>
        <span>{axisLabels.right}</span>
      </div>
    </div>
  )
}
